export default [// { url: 'auth/login', method: 'post' }
];